<template>
  <div class="chart-container">
    <div class="body">
      <canvas :id="idForChart"></canvas>
    </div>

    <div class="footer">
      <ChartLegend v-for="legend in data" :value="legend.value" :text="legend.label" :color="legend.color" />
    </div>
  </div>
</template>

<script>
import ChartLegend from './ChartLegend.vue';

export default {
  name: 'PieChart',
  components: {
    ChartLegend,
  },
  props: {
    idForChart: {
      type: String,
      required: true,
    },
    data: {
      type: Array,
      default: [
        {
          value: 1,
          label: 'Sem resultados',
          color: '#E1E4E8',
        },
      ],
    }
  },
  data() {
    return {
      chartInstance: null,
    }
  },
  mounted() {
    this.renderChart()
  },
  methods: {
    renderChart() {
      const chartData = this.data.map(item => item.value);
      const chartLabels = this.data.map(item => item.label);
      const chartColors = this.data.map(item => item.color);


      const ctx = document.getElementById(this.idForChart).getContext('2d');

      if (this.chartInstance) {
        this.chartInstance.destroy();
      }

      this.chartInstance = new Chart(ctx, {
        type: 'pie',
        data: {
          datasets: [{
            data: chartData,
            backgroundColor: chartColors,
            borderWidth: 0,
          }],
          labels: chartLabels,
        },
        options: {
          responsive: true,
          legend: {
            display: false
          },
          rotation: 1.5,
          animation: {
            animateRotate: true,
            animateScale: true,
          }
        },
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.chart-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2.5rem;

  .body {
    canvas {
      height: 8.944375rem;
    }
  }

  .footer {
    display: flex;
    flex-wrap: wrap;
    gap: 0.625rem;
  }
}
</style>
